import type { ReactNode } from "react";
import { SmartHeader } from "@/features/showcase/components/SmartHeader";
import { resolveCanonicalAppPath } from "@/lib/auth/landing";
import { useAuthStore } from "@/lib/auth/authStore";
import { Breadcrumbs } from "@/shared/ui";

interface Props { children: ReactNode }

export const PublicAppShell = ({ children }: Props): JSX.Element => {
  const { accessToken, user, profileRole, businessRole, systemRole } = useAuthStore();
  const isAuthenticated = Boolean(accessToken && user);
  const dashboardHref = resolveCanonicalAppPath({ systemRole, profileRole, businessRole });
  return (
    <div className="min-h-screen bg-background">
      <SmartHeader isAuthenticated={isAuthenticated} dashboardHref={dashboardHref} />
      <div className="mx-auto max-w-7xl px-4 pt-4 sm:px-6 lg:px-10">
        <Breadcrumbs rootHref="/" />
      </div>
      <main>{children}</main>
    </div>
  );
};
